export default "__VITE_ASSET__352d648b__"